<div #modalOverlay [@fadeInOut] class="overlay"></div>

<ng-template #modalContainer></ng-template>
